<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <router-link :to="{ name: 'EXSBItemCreate' }" class="mb-1 btn btn-sm btn-primary float-right">{{$t('buttons.create')}}</router-link>
    </template>
    <template #filtering>
      <div class="text-right">
        <button v-if="isFilteringVisible" type="button" class="btn btn-sm fa fa-sync fa-lg btn-link" @click="clearFilters()">
        </button>
        <b-button class="btn-sm float-right" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="userdata_search_collapse" class="mt-2" @input="isFilteringVisible = $event">
          <ItemsFiltering ref="filtering"></ItemsFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading" size="lg"></Loader>
      <p v-else-if="!isLoading && items.length < 1">{{$t('views.exsbitems.list.noItems')}}</p>
      <table v-else class="table table-sm table-striped table-hover">
        <thead>
        <tr>
          <th>{{$t('views.exsbitems.list.itemType')}}</th>
          <th>{{$t('views.exsbitems.list.name')}}</th>
          <th>{{$t('views.exsbitems.list.vatRate')}}</th>
          <th>{{$t('views.exsbitems.list.measure')}}</th>
          <th>{{$t('views.exsbitems.list.category')}}</th>
          <th v-if="displayPriceGroup">{{$t('views.exsbitems.form.priceGroup')}}</th>
          <th v-if="displayPriceGroup">{{$t('views.exsbitems.form.rangeFrom')}}</th>
          <th v-if="displayPriceGroup">{{$t('views.exsbitems.form.rangeTo')}}</th>
          <th>{{$t('views.exsbitems.list.priceNetto')}}</th>
          <th>{{$t('views.exsbitems.list.priceBrutto')}}</th>
          <th>{{$t('views.exsborder.list.tags')}}</th>
          <th colspan="2" />
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <td>
            {{ item['itemType'].name }}
          </td>
          <td>
            {{ item['name'] }}
          </td>
          <td>
            {{ item['vatRate'].range }}
          </td>
          <td>
            {{ item['measure'].name }}
          </td>
          <td>
            {{ item['category'].name }}
          </td>
          <td v-if="displayPriceGroup">
            <span v-if="item.priceGroup">{{ item.priceGroup.name }}</span>
          </td>
          <td v-if="displayPriceGroup">
            <span v-if="item.rangeFrom !== null">{{ item.rangeFrom }}</span>
          </td>
          <td v-if="displayPriceGroup">
            <span v-if="item.rangeTo !== null">{{ item.rangeTo }}</span>
          </td>
          <td>
            {{ item['priceNetto'] }}
          </td>
          <td>
            {{ item['priceBrutto'] }}
          </td>
          <td>
            {{ getOrderTags(item) }}
          </td>
          <td>
            <div class="btn-group float-right">
              <router-link
                tag="button"
                :to="{name: 'EXSBItemShow', params: { id: item['@id'] }}"
                class="btn btn-link fa fa-search fa-lg"
                v-b-tooltip.hover :title="$t('buttons.goto')"
              >
              </router-link>
              <router-link
                tag="button"
                :to="{name: 'EXSBItemUpdate', params: { id: item['@id'] }}"
                class="btn btn-link fa fa-edit fa-lg"
                v-b-tooltip.hover :title="$t('buttons.edit')">
              </router-link>
              <b-dropdown variant="link" size="sm" right text="Right align">
                <template #button-content>
                  <i class="fa fa-bars fa-lg"></i>
                </template>
                <b-dropdown-item v-if="item.state === 1 " @click="archiveItem(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.archive')}}</b-dropdown-item>
                <b-dropdown-item v-if="item.state === 0 " @click="unArchiveItem(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.unArchive')}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="view">
        <pagination
          :view="view"
          :totalItems="totalItems"
          @getPage="getPage($event)"
        ></pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import ItemsFiltering from '@/components/Dashboard/Views/BusinessBundle/exsbitem/components/ItemsFiltering'
import { archive, unArchive } from '@/utils/archive'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  components: {
    ItemsFiltering,
    Loader,
    Pagination,
    BaseTableWrapper
  },

  data () {
    return {
      isFilteringVisible: false
    }
  },

  computed: {
    displayPriceGroup () {
      for (let i in this.items) {
        if (this.items[i].priceGroup) {
          return true
        }
      }
      return false
    },
    ...mapGetters({
      deletedItem: 'exsbitem/del/deleted',
      error: 'exsbitem/list/error',
      items: 'exsbitem/list/items',
      isLoading: 'exsbitem/list/isLoading',
      view: 'exsbitem/list/view',
      totalItems: 'exsbitem/list/totalItems'
    })
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBItemList')
  },

  created () {
    let link = addParamsToQuery('e_x_s_b_items', { state: 1 })
    this.getPage(link)
    this.channelBusinessItems = this.$store.state.Pusher.subscribe('e_x_s_b_items')
    this.channelBusinessItems.bind('e_x_s_b_items', data => {
      this.getPage(link)
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_items')
  },

  methods: {
    ...mapActions({
      getPage: 'exsbitem/list/getItems'
    }),
    getOrderTags (item) {
      return item.itemTags.map(itemTag => {
        return itemTag.tag.tag
      }).join(', ')
    },
    clearFilters () {
      this.$refs.filtering.$data.filters = {
        name: '',
        category: '',
        'itemTags.tag': [],
        state: 1
      }
    },
    archiveItem (id) {
      archive(id, () => {})
    },
    unArchiveItem (id) {
      unArchive(id, () => {})
    }
  }
}
</script>
